import loginImage from "../../assets/img/logo-login.png";
import Button from "@/src/components/Button";
import Input from "@/src/components/Input";
import OtpInput from "@/src/components/OtpInput";
import { useUserStore } from "@/src/store/useUserStore";
import { AuthApi } from "@/src/utils/api/auth";
import {
  englishToPersianNumbers,
  persianToEnglishNumbers,
  validatePhoneNumber,
} from "@/src/utils/helpers";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useRaychatUser, useRaychatChat } from "../Profile/Raychat";
import { sendFCMTokenToServer } from "@/src/utils/firebase/tokenManager";

function Login() {
  const [tel, setTel] = useState<any>("");
  const [otp, setOtp] = useState<any>("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [timer, setTimer] = useState(0);
  const { clearUser, setUser } = useUserStore();
  const { setUserRaychat } = useRaychatUser();

  useRaychatChat(
    "c8315074-c017-4d75-9eed-87f3fdafa4b6",
    {
      mobile: { marginRight: 20, marginBottom: 80, marginLeft: 10 },
      desktop: { marginRight: 100, marginBottom: 50, marginLeft: 30 },
    }
  );

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerHeight > 740);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [timer]);

  const handleInputChange = (e: any) => {
    const inputValue = e.target.value;
    setTel(persianToEnglishNumbers(inputValue));
  };

  const handleResendCode = async () => {
    const englishTel = persianToEnglishNumbers(tel || "");
    try {
      await AuthApi.sendOtp(englishTel);
      setTimer(120);
      toast.success("کد یکبار مصرف مجدداً ارسال شد");
    } catch (err: any) {
      console.log("خطای ارسال مجدد OTP:", err);
      toast.error(
        err.response?.data?.message || "خطا در ارسال مجدد کد یکبار مصرف"
      );
    }
  };
  return (
    <div>
      <div className="img flex justify-center pt-10">
        <img src={loginImage} alt="" className="max-w-[260px]" />
      </div>
      <div className="flex justify-center mt-10 flex-col items-center gap-4">
        {!isOtpSent ? (
          <Input
            type="text"
            placeholder="تلفن همراه"
            name="tel"
            onChange={handleInputChange}
            value={englishToPersianNumbers(tel || "")}
          />
        ) : (
          <div className="text-center">

            <p className="text-sm text-gray-600 mb-4 cursor-pointer text-primary-300" onClick={() => {
              setIsOtpSent(false);
              setOtp("");
              setTimer(0);
            }}>
              تغیر شماره موبایل {englishToPersianNumbers(tel || "")}
            </p>
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={4}
              shouldAutoFocus={true}
            />
            <div className="mt-4 text-center">
              {timer > 0 ? (
                <div className="text-xs text-gray-500">
                  ارسال مجدد کد در {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
                </div>
              ) : (
                <button
                  type="button"
                  className="text-xs text-blue-600 hover:text-blue-800 cursor-pointer underline"
                  onClick={handleResendCode}
                >
                  دریافت دوباره کد
                </button>
              )}
            </div>
          </div>
        )}
        <Button
          disabled={
            isOtpSent 
              ? (otp.length > 3 ? false : true)
              : (validatePhoneNumber(tel) ? false : true)
          }
          onClick={async () => {
            if (!isOtpSent) {
              const englishTel = persianToEnglishNumbers(tel || "");
              try {
                await AuthApi.sendOtp(englishTel);
                setIsOtpSent(true);
                setTimer(120);
                toast.success("کد یکبار مصرف ارسال شد");
              } catch (err: any) {
                console.log("خطای ارسال OTP:", err);
                toast.error(
                  err.response?.data?.message || "خطا در ارسال کد یکبار مصرف"
                );
              }
            } else {
              Object.keys(localStorage).forEach(key => {
                if (key.startsWith('raychat')) {
                  localStorage.removeItem(key);
                }
              });

              if (typeof window.Raychat !== "undefined") {
                window.Raychat.openWidget();
              } else {
                console.error("Raychat is not initialized yet.");
              }
              const englishTel = persianToEnglishNumbers(tel || "");

              try {
                await AuthApi.loginWithOtp(englishTel, otp);

                try {
                  const res = await AuthApi.profile();
                  setUser(res.data);
                  toast.success("با موفقیت وارد شدید.");
                  if (res.data && res.data.alias && res.data.mobilePhoneNumber) {
                    setUserRaychat({
                      name: res.data.alias,
                      phone: res.data.mobilePhoneNumber,
                      email: res.data.email || "",
                    });
                    console.log({
                      name: res.data.alias,
                      phone: res.data.mobilePhoneNumber,
                    });
                  }
                  try {
                    if (res.data?.id) {
                      await sendFCMTokenToServer(res.data.id);
                    }
                  } catch (fcmError) {
                    console.error("خطا در ارسال توکن Firebase:", fcmError);
                  }
                } catch (err: any) {
                  console.log("خطای پروفایل:", err);
                  if (err.response?.status === 401) {
                    clearUser();
                  }
                  toast.error(
                    err.response?.data?.message || "خطا در دریافت اطلاعات پروفایل"
                  );
                }
              } catch (err: any) {
                console.log("خطای لاگین:", err);
                toast.error(
                  err.response?.data?.message || "خطا در ورود به سیستم"
                );
              }
            }
          }}

        >
          {isOtpSent ? "ورود" : "دریافت کد"}
        </Button>

        <span
          className="text-xs cursor-pointer font-bold text-primary-300"
          onClick={() => {
            window.location.href =
              "https://mamanpaz.ir/web/chefRegistration?utm_source=app&utm_medium=login&utm_campaign=appchef";
          }}
        >
          ثبت نام در سایت
        </span>
        <span className={`text-gray-200-mmpz text-sm text-center w-[80%] ${isLargeScreen ? 'fixed bottom-10' : 'relative mt-4'}`}>
          با ثبت نام در مامان‌پز، <b className="text-[#4d70e6] font-normal cursor-pointer" onClick={() => {
            window.open("https://mamanpaz.ir/web/eula");
          }}>شرایط و قوانین</b> و{" "}
          <b className="text-[#4d70e6] font-normal cursor-pointer" onClick={() => {
            window.open("https://blog.mamanpaz.ir/%D8%B3%DB%8C%D8%A7%D8%B3%D8%AA-%D8%AD%D8%B1%DB%8C%D9%85-%D8%AE%D8%B5%D9%88%D8%B5%DB%8C/");
          }}>بیانیه حریم خصوصی</b> را
          قبول میکنم.
        </span>
      </div>
    </div>
  );
}

export default Login;
